import { Stack, Typography } from '@mui/material';

import { TooltipContentProps } from '@occc/ui-design-system';
import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';

import { formatDowntimeMinutes } from './store-downtime-chart.utils';

export const StoreDowntimeChartTooltip = ({ payload }: TooltipContentProps) => {
  if (!payload || !payload.length) {
    return null;
  }

  const nonZero = payload.find((p) => typeof p.value === 'number' && (p.value as number) > 0);
  const lowBucket = payload.find(
    (p) => typeof p.dataKey === 'string' && p.dataKey.endsWith('.low'),
  );
  const active = nonZero || lowBucket || payload[0];

  if (active.value == null) {
    return null;
  }

  const formattedDate = formatDateTime(
    active.payload.date,
    DateTimeFormat.DayOfWeekWithShortMonthDate,
  );

  const downtimeMinutes = active.value as number;
  const downtimeLabel = formatDowntimeMinutes(downtimeMinutes);

  const color = active.color;

  return (
    <>
      <Typography variant='subtitle2' mb={1} noWrap>
        {formattedDate}
      </Typography>
      <Stack direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
        <Typography variant='caption' color='text.secondary'>
          Downtime
        </Typography>
        <Typography variant='subtitle2' sx={{ color }} noWrap>
          {downtimeLabel}
        </Typography>
      </Stack>
    </>
  );
};
